<app-nav-bar></app-nav-bar>

<div class="auth-container">
    <div class="auth-header">
        <div class="header-content">
            <h1 class="auth-title">Sign In to UpBoards</h1>
            <p class="auth-subtitle">Access your dealership boards and manage your team</p>
        </div>
    </div>

    <div class="auth-card">
        <firebase-ui
            (signInSuccessWithAuthResult)="successCallback($event)"
            (signInFailure)="errorCallback($event)"
            (uiShown)="uiShownCallback()"
        ></firebase-ui>
    </div>

    <div class="auth-footer">
        <p class="footer-text">
            <span class="footer-icon">🔒</span>
            Your data is secure and encrypted
        </p>
    </div>
</div>